

























































import {Vue,Component, Prop} from 'vue-property-decorator';
import MetricsMixin from 'src/views/reports/pickers/base/metrics-mixin';
import { mixins } from 'vue-class-component';
import ReportBase from '@/views/reports/report-base';
import { reportTypeFromRoute } from '@/services/utils/reportType';
import ColumnsSettingsDialogMixin from '@/views/reports/pickers/cores/columns-settings-dialog/columns-settings-dialog-mixin';

import ColumnSettingsApi from 'src/services/rest/bemob/column-settings';
import { showTotalTypeForColumn } from '@/views/formatters';
const columnSettingsApi: ColumnSettingsApi = new ColumnSettingsApi();

@Component
export default class ReportTotalSettings extends mixins<MetricsMixin,ReportBase,ColumnsSettingsDialogMixin>(MetricsMixin,ReportBase,ColumnsSettingsDialogMixin){
  metricsSettings = {};
  
  close() {
    this.$emit('close');
  }
  
  get savedColumns(){
   return this.$store.getters.getColumns[this.storeColumns]
  }
  
  get allNumberMetrics(){
   return this.savedColumns.columns.filter(item=>showTotalTypeForColumn(item))
  }

  mounted() {
    this.metricsSettings = this.allNumberMetrics.reduce((acc,item)=>{
      acc[item]=this.savedColumns?.totalType?.[item] || 'def'
      return acc
    },{})

  } 
  
  submit() {
    const currentType = reportTypeFromRoute();

    const inheritColumns = !this.$store.state.user.independentColumnSettingsEnabled
    const { groupBy } = this.$store.getters.reportParams

    const contexts =  inheritColumns ? Object.keys(this.$store.getters.savedColumnsInCurentPreset) : [groupBy]

    const resultColumns = contexts.reduce((acc, dimension: string)=>{
      const savedContextData = this.$store.getters.savedColumnsInCurentPreset[dimension]

      const columnsContext = {
        context:savedContextData.context,
        order: savedContextData.order,
        columns:savedContextData.columns.map((column=>({
          name: column,
          width: savedContextData.width[column],
          ...(['avg','sum'].includes(this.metricsSettings[column]) && { totalType: this.metricsSettings[column] })
        })))
      }

      if (!!this.$store.state.table.activeTab && currentType !== 'live-clicks' && currentType !== 'live-visits') {
        acc.local.push(columnsContext)
      } else {
        if(this.isMetricAllowToInherit(inheritColumns, dimension, currentType)) {
          const {columnsFront, widthFront, totalType} = columnsContext.columns.reduce((acc,{name, width, totalType})=>{
            acc.widthFront[name] = width;
            acc.columnsFront.push(name);
            if(totalType){
              acc.totalType[name]  = totalType;
            }
            return acc;
          },{columnsFront :[], widthFront : {}, totalType : {}})
          acc.front[dimension]={
            ...columnsContext,
            columns:columnsFront,
            width:widthFront,
            totalType
          };
          
          if(this.allowToSaveThisMetricOnServer) {
            acc.server.push(columnsContext);
          }
        }
      }
      return acc;
    }, { front:{...this.$store.getters.getDefaultColumns}, server: [], local: [] })

    if (currentType === 'live-visits' ||currentType === 'live-clicks' || !this.$store.state.table.activeTab) {
      this.$store.commit('loading', true);
      columnSettingsApi.putColumnSettings({
        id: this.$store.state.report.activePreset,
        name:this.$store.getters.activePresetData.presetName,
        settings: resultColumns.server
      }).finally(()=> {
        this.$store.commit('updatePreset', {
          presetId: this.$store.state.report.activePreset,
          presetData:resultColumns.front
        });
        this.bus.emit('reload-report')
        this.$store.commit('loading', false);
        this.close();
      })
    }

    if (resultColumns.local.length) {
      this.$store.dispatch('setActiveReportColumns', resultColumns.local)
      this.close();
    }
  }

  
}
